export type DyslexiaScreenerListDisabledTableReason =
  | 'saving'
  | 'dirty'
  | 'contact';

export const DYSLEXIA_SCREENER_LIST_LEA_CONTACT_SAVE_PROMPT =
  'Save LEA Dyslexia Contact Information';

const WHILE_SAVING_CONTACT = 'while saving contact';
const WHILE_FORM_HAS_UNSAVED_CHANGES = 'while form has unsaved changes';

export const dyslexiaScreenerListNotifications = {
  contactEdited: 'Dyslexia screener contact edited',
  contactSaved: 'Dyslexia screener contact saved',
} as const;

export const dyslexiaScreenerListSaveButtonTooltips = {
  noChanges: '**No changes have been made**',
  requiredFieldsIncomplete: '**Make sure all required fields are complete**',
  saveChanges: `**${DYSLEXIA_SCREENER_LIST_LEA_CONTACT_SAVE_PROMPT} Changes**`,
} as const;

export const dyslexiaScreenerListCancelButtonTooltips = {
  noChangesToCancel: 'No changes to cancel',
  cancelChanges: 'Cancel Changes',
} as const;

export function getDyslexiaScreenerListDisabledTableReason(
  isSaving: boolean,
  isFormDirty: boolean,
  persistedLeaContactComplete: boolean
): DyslexiaScreenerListDisabledTableReason | null {
  if (isSaving) return 'saving';
  if (isFormDirty) return 'dirty';
  if (!persistedLeaContactComplete) return 'contact';
  return null;
}

export function getDyslexiaScreenerListDisabledTableTooltip(
  kind: 'schoolYear' | 'filter' | 'edit',
  reason: DyslexiaScreenerListDisabledTableReason | null
): string {
  if (!reason) return '';
  if (reason === 'saving') {
    return kind === 'schoolYear'
      ? `Cannot change school year ${WHILE_SAVING_CONTACT}`
      : kind === 'edit'
      ? `Cannot edit ${WHILE_SAVING_CONTACT}`
      : `Cannot change filters ${WHILE_SAVING_CONTACT}`;
  }
  if (reason === 'dirty') {
    return kind === 'schoolYear'
      ? `Cannot change school year ${WHILE_FORM_HAS_UNSAVED_CHANGES}`
      : kind === 'edit'
      ? `Cannot edit ${WHILE_FORM_HAS_UNSAVED_CHANGES}`
      : `Cannot change filters ${WHILE_FORM_HAS_UNSAVED_CHANGES}`;
  }
  const p = DYSLEXIA_SCREENER_LIST_LEA_CONTACT_SAVE_PROMPT;
  return kind === 'schoolYear'
    ? `${p} before changing school year`
    : kind === 'edit'
    ? `${p} before viewing or editing screener entries`
    : `${p} before using filters`;
}

export function getDyslexiaScreenerListSaveButtonTooltip(
  dirty: boolean,
  isValid: boolean
): string {
  if (!dirty && isValid) {
    return dyslexiaScreenerListSaveButtonTooltips.noChanges;
  }
  if (dirty && !isValid) {
    return dyslexiaScreenerListSaveButtonTooltips.requiredFieldsIncomplete;
  }
  return dyslexiaScreenerListSaveButtonTooltips.saveChanges;
}

export function getDyslexiaScreenerListCancelButtonTooltip(
  dirty: boolean,
  isValid: boolean
): string {
  if (!dirty && isValid) {
    return dyslexiaScreenerListCancelButtonTooltips.noChangesToCancel;
  }
  return dyslexiaScreenerListCancelButtonTooltips.cancelChanges;
}
